import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import router from "@/router";
import { getComponentUiText } from "@/utils/utilities";
import Button1 from "@/components/common/button1.vue";
import CybersystemLogo from "@/components/svgs/cybersystemLogo.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'vendorBasicPage',
  props: {
  mainClass: {
    type: String,
    required: false,
    default: "",
  },
  headerClass: {
    type: String,
    required: false,
    default: "",
  },
  bodyClass: {
    type: String,
    required: false,
    default: "",
  },
},
  setup(__props) {

const prop = __props;


const onNavigateToLandingPage = () => {
  const query = { openModal: "true" };
  router.push({ path: "/", query });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`tw-h-[100%] tw-flex tw-bg-white tw-flex-col ${__props.mainClass}`)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(`tw-px-[14px] tw-py-[10px] tw-items-center tw-justify-between tw-flex ${__props.headerClass}`)
    }, [
      _createVNode(CybersystemLogo),
      _createVNode(Button1, {
        id: `vendro-basic-header-btn`,
        class: _normalizeClass(`!tw-w-[160px] !tw-h-[36px] tw-rounded-[100px] tw-bg-[#387DFF] tw-text-white tw-text-[13px] tw-font-[poppins] tw-text-center tw-font-[500]`),
        title: 
          _unref(getComponentUiText)('app-vendor-base-page-join-cybersystem-button-1')
        ,
        disabled: false,
        onClick: onNavigateToLandingPage
      }, null, 8, ["title"])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(`tw-w-[100%] ${__props.bodyClass} vendor-container`)
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ], 2))
}
}

})